import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {

    static targets = [
        'errorMessage',
        'hourlyRateFromInput',
        'hourlyRateToInput',
        'hourlyRateCheckbox',
    ];

    openModal() {
        $(this.element).modal({
            backdrop: 'static',
            focus: false,
            show: true,
        });
    }

    async submitForm() {
        showPreloader();

        const selectedPricingTypes = [];
        const checkboxes = document.querySelectorAll('[data-pricing-type-checkbox]');

        checkboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                selectedPricingTypes.push(checkbox.value);
            }
        });

        const formData = new FormData();
        formData.append('pricing_types', selectedPricingTypes);

        if (this.hourlyRateCheckboxTarget.checked) {
            if (this.hourlyRateFromInputTarget.value === '' || this.hourlyRateToInputTarget.value === '') {
                this.errorMessageTarget.classList.remove('d-none');
                hidePreloader();
                return;
            }

            this.errorMessageTarget.classList.add('d-none');
            formData.append('hourly_rate_from', this.hourlyRateFromInputTarget.value);
            formData.append('hourly_rate_to', this.hourlyRateToInputTarget.value);
        }

        fetch(routes['app_profile_updatepricingtypes'], {
            method: 'POST',
            body: formData,
        })
            .then((response) => {
                if (response.status) {
                    dataLayer.push({
                        event: 'dataLayer.gaEvent',
                        gaEvent: {
                            'category': 'Account',
                            'action': 'pricing_method | Success',
                            'label': GA_EVENT_LABEL,
                        },
                    });

                    addAlert('success', translations['profile.Changes saved!']);
                    window.location.reload();
                }
            })
            .catch((error) => {
                dataLayer.push({
                    event: 'dataLayer.gaEvent',
                    gaEvent: {
                        'category': 'Account',
                        'action': 'pricing_method | Failure',
                        'label': GA_EVENT_LABEL,
                    },
                });

                hidePreloader();

                addAlert('danger', translations['profile.An unknown error occurred.']);
            });
    }

    updateHourlyRateError() {
        if (this.hasHourlyRateCheckboxTarget && this.hourlyRateCheckboxTarget.checked) {

            if (this.hourlyRateFromInputTarget.value && this.hourlyRateToInputTarget.value) {
                this.errorMessageTarget.classList.add('d-none');
            }
        }
    }
}

